<template class="full-heigth">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="articleItem-app-container" style="position: relative; height: 100%">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ArticleItem',
  components: {},
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
